<template>
  <f7-page
    class="main-sales-receipt-data"
    :page-content="false"
  >
    <template #fixed>
      <TheNavbar
        :nav-title="`${albaran.Serie} / ${albaran.Numero}`"
        :back-btn-enable="true"
        :back-callback="Back"
        :style="appTheme"
      />
    </template>
    <div class="content-form-data-order margin-horizontal margin-bottom-half">
      <div>
        <div class="margin-left-half texto margin-top-half">
          {{ $t('commercialization.common.senderName') }}
        </div>

        <f7-list no-hairlines-md>
          <f7-list-input
            class="input-normal"
            type="text"
            floating-label
            clear-button
            :value="nombreRemitente"
            @input="nombreRemitente = $event.target.value"
          />
        </f7-list>
      </div>
      <div>
        <div class="margin-left-half texto margin-top-half">
          {{ $t('commercialization.common.senderId') }}
        </div>

        <f7-list no-hairlines-md>
          <f7-list-input
            class="input-normal"
            type="text"
            floating-label
            clear-button
            :value="identificadorFiscalRemitente"
            @input="identificadorFiscalRemitente = $event.target.value"
          />
        </f7-list>
      </div>
      <div>
        <UCSearchEntityERP
          ref="UCDireccionRemitente"
          :title="$t('common.address')"
          :placeholder="$t('searchEntity.address.placeholder.searchAddress')"
          :search-text="$t('searchEntity.address.searchText')"
          :search-cancellation-text="$t('searchEntity.address.searchCancellationText')"
          :search-not-found-text="$t('searchEntity.address.searchNotFoundText')"
          :procedure-for-search="procedureAddress"
          :property-entity-shown-input="['Direccion', 'UsoDireccion', 'Nombre']"
          :property-entity-shown-list-title="['Direccion']"
          :property-entity-shown-list-subtitle="['UsoDireccion', 'Nombre']"
          :min-text-search="0"
          :autofocus-on-deselection="true"
          :auto-focus-on-empty-search-result="true"
          @selection="EventDireccionRemitenteSelected"
        />
      </div>
      <div class="margin-top-half row">
        <div class="col">
          <div class="margin-left-half texto ">
            {{ $t('commercialization.common.cargoCity') }}
          </div>

          <f7-list no-hairlines-md>
            <f7-list-input
              class="input-normal"
              type="text"
              floating-label
              size="20"
              clear-button
              :value="poblacionCargaRemitente"
              @input="poblacionCargaRemitente = $event.target.value"
            />
          </f7-list>
        </div>
        <div class="col">
          <div class="margin-left-half texto">
            {{ $t('common.country') }}
          </div>
          <f7-list no-hairlines-md>
            <f7-list-input
              class="input-select input-normal"
              type="select"
              :value="id_PaisCarga"
              @input="id_PaisCarga = $event.target.value"
            >
              <option
                v-for="pais in paises"
                :key="pais.Id"
                :value="pais.Id"
              >
                {{ pais.NombreComun }}
              </option>
            </f7-list-input>
          </f7-list>
        </div>
      </div>
      <div class="margin-top-half row">
        <div class="col">
          <div class="margin-left-half texto">
            {{ $t('commercialization.common.totalPaletsNumber') }}
          </div>

          <f7-list no-hairlines-md>
            <f7-list-input
              class="input-normal"
              type="Number"
              floating-label
              size="20"
              clear-button
              :value="totalPalets"
              @input="totalPalets = $event.target.value"
            />
          </f7-list>
        </div>
        <div class="col">
          <div class="margin-left-half texto">
            {{ $t('commercialization.common.returnedPallets') }}
          </div>

          <f7-list no-hairlines-md>
            <f7-list-input
              class="input-normal"
              type="Number"
              floating-label
              size="20"
              clear-button
              :value="totalPaletsDevueltos"
              @input="totalPaletsDevueltos = $event.target.value"
            />
          </f7-list>
        </div>
      </div>
      <div>
        <UCSearchEntityERP
          ref="UCDireccionEntrega"
          :title="$t('searchEntity.address.title.deliveryPlaceAddress')"
          :placeholder="$t('searchEntity.address.placeholder.searchAddress')"
          :search-text="$t('searchEntity.address.searchText')"
          :search-cancellation-text="$t('searchEntity.address.searchCancellationText')"
          :search-not-found-text="$t('searchEntity.address.searchNotFoundText')"
          :procedure-for-search="procedureAddress"
          :property-entity-shown-input="['Direccion', 'UsoDireccion', 'Nombre']"
          :property-entity-shown-list-title="['Direccion']"
          :property-entity-shown-list-subtitle="['UsoDireccion', 'Nombre']"
          :min-text-search="0"
          :autofocus-on-deselection="true"
          :auto-focus-on-empty-search-result="true"
          @selection="EventDireccionEntregaSelected"
        />
      </div>
      <div class="margin-top-half">
        <div class="margin-left-half texto">
          {{ $t('common.observations') }}
        </div>
        <textarea
          class="input-text"
          name="textarea"
          rows="1"
          cols="1"
          :value="observaciones"
          @input="observaciones = $event.target.value"
        />
      </div>
      <div class="margin-top-half">
        <div class="margin-left-half texto">
          {{ $t('commercialization.common.additionalObservations') }}
        </div>
        <textarea
          class="input-text"
          name="textarea"
          rows="1"
          cols="1"
          :value="observacionesAdicionales"
          @input="observacionesAdicionales = $event.target.value"
        />
      </div>
      <div>
        <div class="margin-left-half texto margin-top-half">
          {{ $t('common.reference') }}
        </div>

        <f7-list no-hairlines-md>
          <f7-list-input
            class="input-normal"
            type="text"
            floating-label
            clear-button
            :value="referencia"
            @input="referencia = $event.target.value"
          />
        </f7-list>
      </div>
      <div class="margin-top-half row">
        <div class="col">
          <div class="margin-left-half margin-bottom-half texto">
            {{ $t('commercialization.common.loadingDate') }}
          </div>
          <UCDatePicker
            ref="UCDatePicker"
            class="input-normal"
            @onchange="DateChanged"
          />
        </div>
        <div class="col">
          <div class="margin-left-half margin-bottom-half texto">
            {{ $t('commercialization.common.loadingHour') }}
          </div>
          <UCTimePicker
            ref="UCTimePicker"
            class="input-normal"
            :show-input="false"
            template="P2"
            @onchange="TimeChanged"
          />
        </div>
      </div>
    </div>
    <div class="container-btn">
      <f7-button
        class="btn-confirmar"
        fill
        @click="FinishDeliveryNote"
      >
        {{ $t('common.confirm') }}
      </f7-button>
    </div>
  </f7-page>
</template>

<script>
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import APIErp, { callExecuteSPERP, callFetchCountries } from '@/js/services/APIErp';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';
import { f7 } from 'framework7-vue';

/** @import { SPApp } from '@erpagroapp/types' */

export default {
  name: 'FrmExpeditionSalesReceiptData',
  components: {
    TheNavbar,
    UCSearchEntityERP,
    UCTimePicker,
    UCDatePicker,
  },
  props: {
    albaran: { type: Object, required: true },
  },
  data() {
    return {
      documentacionExpedicionCMR: null,
      nombreRemitente: '',
      identificadorFiscalRemitente: 'null',
      direccionRemitente: null,
      poblacionCargaRemitente: '',
      id_PaisCarga: 0,
      totalPalets: 0,
      totalPaletsDevueltos: 0,
      direccionLugarEntrega: null,
      observaciones: '',
      observacionesAdicionales: '',
      referencia: '',
      fechaCarga: null,
      horaCarga: null,
      paises: [],
      procedureAddress: /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_Direcciones',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'Id:' },
          { NombreParametro: 'Id_Cliente', Valor: this.albaran.Cliente.Id },
        ],
        EntidadMapear: 'DireccionJSON',
      }),
    };
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },
  mounted() {
    this.StartComponent();
  },
  methods: {
    async StartComponent() {
      Log(this, this.StartComponent.name);
      HiDialog.Preloader(true, this.$t('commercialization.info.loadingCmrData'), false);
      await this.GetSaleReceiptsExpeditionDocument(this.albaran.Id);
      await this.LoadCountries();
      this.nombreRemitente = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.NombreRemitente;
      this.identificadorFiscalRemitente = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.IdentificadorFiscalRemitente;
      this.direccionRemitente = await this.GetAddress(this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.Id_DireccionRemitente);
      this.$refs.UCDireccionRemitente.SelectEntity(this.direccionRemitente, true);
      this.poblacionCargaRemitente = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.PoblacionCargaRemitente;
      this.id_PaisCarga = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.Id_PaisCarga;
      this.totalPalets = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.TotalPalets;
      this.totalPaletsDevueltos = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.TotalPaletsDevueltos;
      this.direccionLugarEntrega = await this.GetAddress(this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.Id_DireccionLugarEntrega);
      this.$refs.UCDireccionEntrega.SelectEntity(this.direccionLugarEntrega, true);
      this.observaciones = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.Observaciones;
      if (this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.ObservacionesAdicionales != null) {
        this.observacionesAdicionales = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.ObservacionesAdicionales.Texto;
      }

      this.referencia = this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.Referencia;
      this.$refs.UCDatePicker.setDate(new Date(this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.FechaCarga));
      this.$refs.UCTimePicker.SetTime(new Date(this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.FechaCarga));
      HiDialog.Preloader(false);
    },
    Back() {
      f7.views.main.router.back();
    },
    EventDireccionRemitenteSelected(value) {
      Log(this, this.EventDireccionRemitenteSelected.name);
      this.direccionRemitente = value;
    },
    EventDireccionEntregaSelected(value) {
      Log(this, this.EventDireccionEntregaSelected.name);
      this.direccionLugarEntrega = value;
    },
    TimeChanged(value) {
      Log(this, this.TimeChanged.name);
      this.horaCarga = value;
    },
    DateChanged(value) {
      Log(this, this.DateChanged.name);
      this.fechaCarga = value;
    },
    async FinishDeliveryNote() {
      Log(this, this.FinishDeliveryNote.name);
      let faltanDatos = false;
      if (this.direccionLugarEntrega === null) {
        faltanDatos = true;
      }
      if (this.direccionRemitente === null) {
        faltanDatos = true;
      }

      if (faltanDatos) {
        HiNotification.Alert(this.$t('commercialization.info.addressesAreRequired'), this.$t('common.warning'));
        return null;
      }

      const docExpedicionCMR = this.documentacionExpedicionCMR;
      docExpedicionCMR.DocumentacionExpedicionCMR.NombreRemitente = this.nombreRemitente;
      docExpedicionCMR.DocumentacionExpedicionCMR.IdentificadorFiscalRemitente = this.identificadorFiscalRemitente;
      docExpedicionCMR.DocumentacionExpedicionCMR.Id_DireccionRemitente = this.direccionRemitente.Id;
      docExpedicionCMR.DocumentacionExpedicionCMR.PoblacionCargaRemitente = this.poblacionCargaRemitente;
      docExpedicionCMR.DocumentacionExpedicionCMR.Id_PaisCarga = this.id_PaisCarga;
      docExpedicionCMR.DocumentacionExpedicionCMR.TotalPalets = this.totalPalets;
      docExpedicionCMR.DocumentacionExpedicionCMR.TotalPaletsDevueltos = this.totalPaletsDevueltos;
      docExpedicionCMR.DocumentacionExpedicionCMR.Id_DireccionLugarEntrega = this.direccionLugarEntrega.Id;
      docExpedicionCMR.DocumentacionExpedicionCMR.Observaciones = this.observaciones;

      if (this.documentacionExpedicionCMR.DocumentacionExpedicionCMR.ObservacionesAdicionales != null) {
        docExpedicionCMR.DocumentacionExpedicionCMR.ObservacionesAdicionales.Texto = this.observacionesAdicionales;
      } else {
        docExpedicionCMR.DocumentacionExpedicionCMR.ObservacionesAdicionales = {
          Id: 0,
          Texto: this.observacionesAdicionales,
        };
      }

      docExpedicionCMR.DocumentacionExpedicionCMR.Referencia = this.referencia;
      this.fechaCarga.setHours(this.horaCarga.split(':')[0]);
      this.fechaCarga.setMinutes(this.horaCarga.split(':')[1]);
      docExpedicionCMR.DocumentacionExpedicionCMR.FechaCarga = HiDateTimeSupport.FormatDateTime(new Date(this.fechaCarga), 'YYYY-MM-DD HH:mm:ss');

      try {
        HiDialog.Preloader(true, this.$t('commercialization.common.savingEllipsis'), false);
        const result = await APIErp.callPrintDocumentExpeditionCMR(docExpedicionCMR, this.albaran.Id);
        HiDialog.Preloader(false);

        if (result.status === 200) {
          this.Back();
        }

        HiDialog.Preloader(false);
        return result;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, this.$t('commercialization.common.anErrorHasOccurred'));
        return null;
      }
    },

    /** **********Conexiones */
    async LoadCountries() {
      Log(this, this.LoadCountries.name);
      await callFetchCountries().then((result) => {
        this.paises = result.data;
      });
    },
    async GetAddress(id) {
      Log(this, this.GetAddress.name);
      let direccion = null;
      await callExecuteSPERP(
        'APPERPAGRO_Direcciones',
        [
          { NombreParametro: 'filtro', Valor: `Id:${id}` },
          { NombreParametro: 'Id_Cliente', Valor: '0' },
        ],
        'DireccionJSON',
      ).then((result) => {
        [direccion] = result.data;
      });

      return direccion;
    },
    async GetSaleReceiptsExpeditionDocument(idAlbaran) {
      Log(this, this.GetSaleReceiptsExpeditionDocument.name);
      // HiDialog.Preloader(true, this.$t('commercialization.info.loadingCmrData'), false);
      await callExecuteSPERP(
        'APPERPAGRO_DocumentoExpedicionCMRXAlbaran',
        [{ NombreParametro: 'Id_AlbaranVenta', Valor: idAlbaran }],
        'Compras.DocumentacionExpedicionJSON',
      ).then((result) => {
        [this.documentacionExpedicionCMR] = result.data;
      });
      // HiDialog.Preloader(false);
    },
  },
};
</script>

<style lang="scss">
.main-sales-receipt-data {
  --search-title-color: var(--f7-block-title-text-color);
  --search-title-font-size: var(--f7-block-title-font-size);
  --available-viewport-height: calc(100vh - 130px - var(--information-bar-height));
  --f7-input-height: 35px;

  .content-form-data-order {
    height: var(--available-viewport-height);
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 60px;
  }

  .list {
    --f7-list-bg-color: transparent;

    ul {
      li {
        --f7-input-font-size: 14px;
        --f7-input-text-color: var(--his-steel-blue);

        background: #fff;
        height: 36px;
        width: 100%;
        margin-top: 5px;
        border: 1px solid var(--his-silver);
        border-radius: 8px;
      }
    }

    ul::before,
    ul::after {
      height: 0;
    }

    .input-normal {
      margin-top: 1vh;
      height: 40px;
    }

    .input-select {
      --f7-input-height: 33px;
    }

    .input-text {
      height: 40px;
    }
  }

  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 8px;
  }

  .input-fecha {
    width: 20vh;
  }

  .input-text {
    width: 100%;
    background: #fff;
    margin-top: 1vh;
    padding: 6px;
    height: 40px;
  }

  .texto {
    line-height: 1;
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size);
  }

  .container-btn {
    display: flex;
    flex-direction: row;
    align-content: space-around;
    align-items: center;

    /* border-top: 1px solid grey; */
    text-align: right;
    width: 100%;
    z-index: 100;
    position: fixed;
    bottom: calc(8px + var(--information-bar-height));
    right: 0;
    padding-top: 2vh;

    .btn-confirmar {
      width: 100%;
      margin-left: 3vh;
      margin-right: 3vh;
      background: var(--his-oliva);
    }
  }
}
</style>
